module.exports = __webpack_public_path__ + "img/nothing-img.99f7b996.png";